// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bridge-5"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M5 13V4L19 4.00084V13C19 13 16.5 10 12 10C7.5 10 5 13 5 13Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M1 20.0004V4H5V20.0004H1Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M23 20.0014V4.00098H19V20.0014H23Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5 4H1V20.0004H5V4ZM5 4L19 4.00084M19 4.00084H23V20.0013H19V4.00084ZM5.5 12.4954C6.43804 11.6407 8.67212 10 12 10C15.3279 10 17.562 11.6407 18.5 12.4954","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bridge-5')
export default class Bridge5Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bridge-5',
    }
  }
}
